<template>
  <v-bottom-navigation
    grow
    color="primary"
    bg-color="surface"
    data-testid="bottom-navigation"
    class="bottom-nav-enhanced"
  >
    <v-btn
      v-for="item in bottomNavItems"
      :key="item.id"
      :to="item.path"
      :value="item.id"
      :data-testid="`nav-${item.id}`"
      :aria-label="item.ariaLabel"
      :aria-current="isActive(item.path) ? 'page' : undefined"
      :active="isActive(item.path)"
    >
      <v-badge v-if="item.badge" :content="item.badge" color="error">
        <v-icon>{{ item.icon }}</v-icon>
      </v-badge>
      <v-icon v-else>{{ item.icon }}</v-icon>
      <span>{{ item.label }}</span>
    </v-btn>
  </v-bottom-navigation>
</template>

<script setup lang="ts">
import { useNavigation } from '@/composables/useNavigation'

const { bottomNavItems, isActive } = useNavigation()
</script>

<style scoped>
.bottom-nav-enhanced {
  border-top: 1px solid rgba(var(--v-theme-primary), 0.12);
}
</style>
